/**
 * Event prefix constants for namespacing events by source
 */
export const EVENT_PREFIX = {
    /** Prefix for events originating from the widget app */
    APP: 'app:',
    /** Prefix for events originating from the host application */
    HOST: 'host:',
};
//# sourceMappingURL=events.js.map